<style scoped></style>

<template>
  <fm-poper-select @change="onChange" :confirm="confirm" :options="options" :clearable="clearable">
    <slot></slot>
  </fm-poper-select>
</template>

<script>
import { taskPriorityList } from '../lib'
export default {
  name: 'task-status-select',
  props: {
    confirm: { type: Boolean, default: true },
    clearable: { type: Boolean, default: true }
  },
  computed: {
    options () {
      return taskPriorityList.map(status => {
        return Object.assign({
          render (status) {
            return '<div class="' + status.cls + '">' + status.label + '</div>'
          }
        }, status)
      })
    }
  },
  methods: {
    onChange (data) {
      this.$emit('change', data)
    }
  },
}
</script>
